import React from 'react';
import { Link } from "react-router-dom";
import gazeta92 from '../../doc/img/logo/gazeta92.jpg';
import gazeta92_mobile from '../../doc/img/logo/gazeta92_mobile.jpg';

import logo from '../../doc/img/logo/logo.png';
import logoDark from '../../doc/img/logo/logowhite.png';
import { useDispatch, useSelector } from "react-redux";
import { getMidiaUrlPropaganda } from '../../store/settings';
import { isMobile } from 'react-device-detect';
import { NavLink } from 'react-router-dom/cjs/react-router-dom';
import * as RadioAction from '../../store/actionsgazeta/radio.actions'

const LogoArea = ({ className, dark }) => {

    const propagandas = useSelector(state => state.gazeta.propagandas)
    const dispatch = useDispatch();

    const getPrograma = () => {

        let data = new Date()
        let diaSemana = data.getDay()
        let hora = data.getHours()
        let minutos = data.getMinutes()

        let imagem = "000_insti"

        //semana de seg a sexta
        

        if (isMobile) imagem = imagem + "_mobile"
        imagem = require("../../doc/img/programacao/" + imagem + ".jpg")


        if (propagandas.filter(propaganda => propaganda.funcao === "Header").length === 0) {
            return <NavLink
                to={"/"}
                onClick={async () => {
                    await dispatch(RadioAction.close())
                    dispatch(RadioAction.set("FM"))
                }}
            >
                <img src={imagem} alt="banner" />
            </NavLink>

        } else {
            return null
        }
    }

    return (
        <div className={`logo_area ${className ? className : ''}`}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 align-self-center" style={{ marginBottom: isMobile ? -10 : 10 }}>
                        <NavLink
                            to={"/"}
                            onClick={async () => {
                                await dispatch(RadioAction.close())
                                dispatch(RadioAction.set("FM"))
                            }}
                        >
                            {
                                isMobile ?
                                    <img src={gazeta92_mobile} alt="gazeta92" />
                                    :
                                    <img src={gazeta92} alt="gazeta92" />
                            }
                        </NavLink>
                    </div>
                    <div className="col-lg-4 align-self-center">
                        <div className="logo">
                            <Link to="/">
                                <img src={dark ? logoDark : logo} alt="logo" style={{ marginTop: 25 }} />
                            </Link>
                        </div>
                    </div>
                    <div className="col-lg-8 align-self-center">
                        <div className="banner1">
                            {
                                propagandas.find(propaganda => propaganda.funcao === "Header") ?
                                    <a target="_blank" rel="noopener noreferrer" href={propagandas.find(propaganda => propaganda.funcao === "Header").link}>
                                        <img src={getMidiaUrlPropaganda(propagandas.find(propaganda => propaganda.funcao === "Header").chave)} alt="banner" />
                                    </a>
                                    : null
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LogoArea;